<template>
	<div class="bankrecharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">西信宝</div>
		</div>


        <uni-view  class="center-page" style="margin-top:44px;font-size: 16px;">
        <uni-view  class="center-view" style="display: block;background-color: #3775f4;">
            <uni-view  class="bank-view" style="display: block;">
            <uni-view  class="qian" style="display: block;font-size: 41px;padding: 12px;">{{data.yuebao}}</uni-view style="display: block;">西信宝余额</uni-view>
            <uni-view  class="dierhang">
            <uni-view  class="left">累计收益：{{data.yuebao_income}}元</uni-view>
            <uni-view  class="right">日化收益：{{data.yuebao_rate}}%</uni-view>
            </uni-view>
        </uni-view>

        <div data-v-535a58b8="" class="recharge_wrap">
        <p data-v-535a58b8="">请输入金额</p>
        <div data-v-535a58b8="" class="flex_center">
            <span data-v-535a58b8="">¥</span>
            <input data-v-535a58b8="" type="number" v-model.trim="money" step="100" placeholder="请输入金额" class="inp" style="
                background: #fff;
                height: 35px;
                border-radius: 5px;
                color: #000;
                font-size: 16px;
            ">
            <!-- <span data-v-535a58b8="">≈￥0.00</span> -->
        </div>
        </div>

        <uni-view  class="dierhang" style="padding-top: 10px; padding-bottom: 10px;">
            <uni-view  class="left" @click="submitBtn(1)">
            <uni-view class="unibutton">转入</uni-view>
            </uni-view>
            <uni-view  class="right" @click="submitBtn(2)">
            <uni-view  class="unibutton">转出</uni-view>
            </uni-view>
        </uni-view>
        <uni-view  class="table_biaoti">近72笔收益记录</uni-view>
        <uni-view >

            <uni-view  class="list-view" v-for="item in data.yuebaolist">
                <uni-view  class="item-content-view">
                    <uni-view  class="item-content-title">{{item.addtime}} 收益
                    <uni-text  class="money red">
                        <span>+{{item.money}}元</span>
                    </uni-text>
                    </uni-view>
                    <uni-view  class="item-content-desc">
                    </uni-view>
                </uni-view>
            </uni-view>
            
        </uni-view>
        </uni-view>

	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Button
	} from "vant";
	import Fetch from "../../utils/fetch";

	Vue.use(Button);

	export default {
		name: "yuebao",
		data() {
			return {
				data: {},
                configdata: {},
				money: '',
			};
		},
		created() {
			this.$parent.footer("user", false);
		},
		mounted() {
			this.start();
		},
		methods: {
            start() {
                Fetch("/user/info").then((r) => {
                    this.data = r.data;
                });
            },
			submitBtn(type) {
                var that=this;
				if (!this.money) {
					this.$toast('请输入金额');
					return false;
				}				
				Fetch("/user/yuebao_apply", {
					money: this.money,
                    type:type
				}).then((r) => {
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t(r.info),
						});
                        setTimeout(function() {
                            that.start();
                        }, 2000);
					}
				});
			}
		},
	};
</script>

<style lang="less" scoped>
.red_top_bg{width:100%;max-width:750px;height:44px;margin:0 auto;background:#fff;background-size:100% 100%;overflow:hidden;}
.big_tit{position:absolute;height:25px;font-size:18px;font-weight:500;color:#fff;line-height:25px;top:12px;left:50%;transform:translateX(-50%);}
.back_left{width:20px;height:20px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAoCAMAAADNGvrUAAAAS1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////+DmQsHAAAAGHRSTlMABwkTICssLS9FaHZ9iI6PzNri6erv9/4ppXzqAAAAVElEQVQoz+3TORKAIBAAwfUAb0EFnf+/1NxdH0AVE3Y+It9czItC8Qme3lLNPgFspoaqpjpTJZoqGbgHxSvA5ZWHkjwV4mdr+6jn2eFoNMs0d/LTCzd6E3GEJ9CYAAAAAElFTkSuQmCC) no-repeat 50%;background-size:auto 100%;margin:12px 0 0 8px;}
div,p,span{margin:0;padding:0;border:0;font-size:100%;outline:none;-webkit-appearance:none;border:none;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-text-size-adjust:none;word-break:break-all;}
.red_top_bg{background:#3775f4;background-size:100% 100%;position:fixed;z-index:15;}
.money_box{margin-top:29px;display:flex;padding:0 6px;justify-content:space-around;color:#fff;}
.money_box .item{width:33.33%;text-align:center;font-weight:700;}
.money_box .item .money_num{font-size:18px;line-height:25px;white-space:normal;word-break:normal;text-align:center;}
.money_box .item .info{font-size:14px;line-height:20px;margin-top:5px;}

.table_biaoti{text-align:center;padding:10px;border-bottom:1px #3775f4 solid}.list-view{position: relative;padding:10px;display:flex;border-bottom:1px solid #ccc}.list-view .list-item-img{width:14px;height:14px}.list-view .list-item-img uni-image{width:100%;height:100%}.list-view .item-content-view{padding-left:10px}.list-view .item-content-view .item-content-title{line-height:23px;font-size:14px;padding-bottom:5px;color:#333}.list-view .item-content-view .item-content-title .money{position:absolute;font-size:16px;font-weight:700;padding-top:2px;right:20px;color:#333}.list-view .item-content-view .item-content-title .red{color:red}.center-page{display:flex;flex-direction:column;width:100%}.dierhang{height:52px;line-height:52px;background:#3775f4;color:#fff;}.dierhang .left{text-align:center;float:left;width:50%}.dierhang .left .unibutton{width:80%;height:41px;line-height:41px;margin-top:5px;background:#000;color:#fff}.dierhang .right{text-align:center;float:right;width:50%}.dierhang .right .unibutton{width:80%;height:41px;line-height:41px;margin-top:5px;background:#e7544d;color:#fff}.center-view{flex:1;position:relative}.center-view .bank-view{text-align:center;padding:26px;background-color:#3775f4;color:#fff}.center-view .bank-view .qian{font-size:41px}.footer{line-height:52px;flex:0 0 52px;margin:26px}.footer .unibutton{background-color:#3775f4}
.unibutton {
    position: relative;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-left: 14px;
    padding-right: 14px;
    box-sizing: border-box;
    font-size: 18px;
    text-align: center;
    text-decoration: none;
    line-height: 2.55555556;
    border-radius: 5px;
    -webkit-tap-highlight-color: transparent;
    overflow: hidden;
    color: #000;
    background-color: #3775f4;
    cursor: pointer;
}

input{color:inherit;font:inherit;}
input:focus{outline:0;}
.flex_center{display:flex;justify-content:center;align-items:center;color: #fff;}
div,input,p,span{margin:0;padding:0;border:0;font-size:100%;outline:none;-webkit-appearance:none;border:none;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-text-size-adjust:none;word-break:break-all;}
input{outline:none;-webkit-appearance:none;border:none;background:none;}
input{line-height:normal;}
input{-webkit-appearance:button;}
.recharge_wrap[data-v-535a58b8]{width:100%;background:#3775f4;padding:16px 20px;}
.recharge_wrap input[data-v-535a58b8]{height:18px;width:60%;line-height:18px;font-size:14px;}
.recharge_wrap div span[data-v-535a58b8]:first-child{font-size:18px;margin-right:10px;font-weight:700;}
.recharge_wrap div span[data-v-535a58b8]:nth-child(3){font-size:14px;width:40%;color:#fff;text-align:right;}
.recharge_wrap p[data-v-535a58b8]:first-child{font-size:16px;font-weight:700;color:#fff;margin-bottom:20px;}
</style>
